module.exports = {
  "zones": {
    "Indian/Maldives": ["z", {
      "wallclock": -315619200000,
      "format": "+05",
      "abbrev": "+05",
      "offset": 18000000,
      "posix": -315636840000,
      "save": 0
    }, {
      "wallclock": -2840140800000,
      "format": "MMT",
      "abbrev": "MMT",
      "offset": 17640000,
      "posix": -2840158440000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 17640000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {}
};